var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: { subtitle: _vm.plotNameAndType, "no-padding": "" },
      }),
      _vm._v(" "),
      _vm.isLoading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.hasData
        ? _c(
            "v-tabs",
            {
              attrs: { dark: "", grow: "", centered: "" },
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              _c(
                "v-tab",
                { attrs: { href: "#tab-1" } },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("assignment")]),
                  _vm._v("Summary\n    "),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-tab", { attrs: { href: "#tab-2" } }, [
                _vm._v("\n      Plot Surveys\n    "),
              ]),
              _vm._v(" "),
              _c("v-tab", { attrs: { href: "#tab-3" } }, [
                _vm._v("\n      Specimen Surveys\n    "),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              _c(
                "v-tab-item",
                { attrs: { value: "tab-1" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [_c("SummaryTab", { attrs: { value: _vm.plot } })],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-2" } },
                [_c("PlotSurveyQueryTab", { attrs: { value: _vm.plot } })],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-3" } },
                [_c("SpecimenSurveyQueryTab", { attrs: { value: _vm.plot } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }